import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { PropertiesBase as p } from "../common/properties-base.js";
var FeatureFlag = /*#__PURE__*/function (_p) {
  _inherits(FeatureFlag, _p);
  var _super = _createSuper(FeatureFlag);
  function FeatureFlag(s) {
    var _this;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var e = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, FeatureFlag);
    _this = _super.call(this, i), _this.id = s, _this.enabled = t, _this.trackingString = e, _this.id = s, _this.enabled = t, _this.trackingString = e;
    return _this;
  }
  _createClass(FeatureFlag, [{
    key: "dt",
    value: function dt() {
      var s = {};
      return s[FeatureFlag.ss.rs] = this.id, s[FeatureFlag.ss.Fe] = this.enabled, s[FeatureFlag.ss.we] = this.properties, s[FeatureFlag.ss.xe] = this.trackingString, s;
    }
  }]);
  return FeatureFlag;
}(p);
export { FeatureFlag as default };
FeatureFlag.ss = {
  rs: "id",
  Fe: "e",
  we: "pr",
  xe: "fts"
}, FeatureFlag.ui = {
  rs: "id",
  Fe: "enabled",
  we: "properties",
  xe: "fts"
};